import http from 'services/http';
import type { QuestionReportStatus } from './constants';
import type { AttemptQuestionReports, QuestionReport, QuestionReportInbox, QuestionReportInput } from './types';

/** The caller's own reports on one attempt. A guest is recognised by the session token the client already sends. */
export async function getAttemptQuestionReports(attemptId: string, signal?: AbortSignal): Promise<AttemptQuestionReports> {
  const { data } = await http.request.get<{ data: AttemptQuestionReports }>(
    `/api/question-reports/attempts/${encodeURIComponent(attemptId)}`,
    { signal },
  );
  return data.data;
}

export async function saveQuestionReport(
  attemptId: string,
  questionId: string,
  input: QuestionReportInput,
): Promise<QuestionReport> {
  const { data } = await http.request.put<{ data: QuestionReport }>(
    `/api/question-reports/attempts/${encodeURIComponent(attemptId)}/questions/${encodeURIComponent(questionId)}`,
    input,
  );
  return data.data;
}

/** The reported questions of one test of the active organization (the X-Organization-Id header is added by the client). */
export async function getQuestionReportInbox(
  testId: string,
  status: QuestionReportStatus,
  signal?: AbortSignal,
): Promise<QuestionReportInbox> {
  const { data } = await http.request.get<{ data: QuestionReportInbox }>(
    `/api/question-reports/tests/${encodeURIComponent(testId)}`,
    { params: { status }, signal },
  );
  return data.data;
}

export async function setQuestionReportStatus(
  testId: string,
  questionId: string,
  status: QuestionReportStatus,
): Promise<{ updated: number }> {
  const { data } = await http.request.patch<{ data: { updated: number } }>(
    `/api/question-reports/tests/${encodeURIComponent(testId)}/questions/${encodeURIComponent(questionId)}`,
    { status },
  );
  return data.data;
}
